module.exports = __webpack_public_path__ + "static/cover-1b3d3ffdfcc311fb28e5af0b4fa1b0fb.jpeg";